import { render, staticRenderFns } from "./TrailerModal.vue?vue&type=template&id=5819d9da"
import script from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrailerModal.vue?vue&type=style&index=0&id=5819d9da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports